import React, { useEffect, useState } from "react";
import "../../styles/pages/cardd.css"

const AdventCard = ({ text, t }) => {
  const [flippedd, setFlippedd] = useState(false);
  const current = new Date()
  const day = current.getDate();

  useEffect(() => {
    const flipped = localStorage.getItem(`flipped-${t.id}`);
    if (flipped) {
      setFlippedd(JSON.parse(flipped));
    }
  }, [t.id]);

  const handleClick = () => {
    if (t.id <= day) {
      setFlippedd(true);
      localStorage.setItem(`flipped-${t.id}`, true);
    } else {
      setFlippedd(false);
      localStorage.removeItem(`flipped-${t.id}`);
    }
  };
  return (
      <div className="cardd" key={t.id}>
        <div className={flippedd ? "flippedd" : ""}>
          <div className="frontt">
            <p className="pp">{t.id}</p>
            <h2 className="h22" style={{fontSize: '1em'}}>{text}</h2>
          </div>
          {!flippedd && (
              <div>
                <h2 className="backk" style={{color: 'green', textAlign: 'center'}} onClick={handleClick}>
                  {t.id}
                </h2>
              </div>
          )}
        </div>
      </div>
  );
};
export default AdventCard;
